import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'

import {
    CheckCircleOutlineOutlined, ErrorOutlineOutlined
} from '@material-ui/icons'

function FeedbackLabel({ classes, children, type, ...restProps }) {
    const getColor = () => {
        switch (type) {
            case 'success':
                return classes.success
            case 'error':
                return classes.error
            default:
                return <></>
        }
    }

    const getIcon = () => {
        switch (type) {
            case 'success':
                return <CheckCircleOutlineOutlined style={{ marginRight: '5px' }} />
            case 'error':
                return <ErrorOutlineOutlined style={{ marginRight: '5px' }} />
            default:
                return <></>
        }
    }

    return (
        <Typography className={`${classes.root} ${getColor()}`} {...restProps}>
            {getIcon()}
            {children}
        </Typography>
    )
}

const styles = theme => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        userSelect: 'none',
        fontWeight: 'bold'
    },
    success: {
        color: theme.palette.success.dark
    },
    error: {
        color: theme.palette.error.dark
    }
});

export default withStyles(styles)(FeedbackLabel)